'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'chess-rook';
var width = 448;
var height = 512;
var aliases = [9820];
var unicode = 'f447';
var svgPathData = 'M32 208L32 32l96 0 0 64 48 0 0-64 96 0 0 64 48 0 0-64 96 0 0 176-64 48 16 144L80 400 96 256 32 208zm160 16l0 64 64 0 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zM16 512l0-32 48-48 320 0 48 48 0 32L16 512z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChessRook = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;